module.exports = __webpack_public_path__ + "static/img/home_new17.06926f75.jpg";